import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    className?: string
    tone?: 'dark' | 'light'
    showName?: boolean
}

export const LogoMark: FC<{ className?: string }> = ({ className }): ReactNode => {
    return (
        <span
            aria-hidden='true'
            className={cn(
                'grid size-9 shrink-0 place-items-center rounded-xl bg-primary font-heading text-lg font-bold text-primary-foreground shadow-[0_8px_18px_-8px_rgb(53_102_219/0.8)]',
                className
            )}
        >
            E
        </span>
    )
}

export const Logo: FC<LogoProps> = ({ className, tone = 'dark', showName = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark />

            {showName && (
                <span
                    className={cn(
                        'font-heading text-xl font-bold tracking-tight',
                        tone === 'light' ? 'text-white' : 'text-foreground'
                    )}
                >
                    {siteConfig.name}
                </span>
            )}
        </span>
    )
}
